import { apiFetch } from "../utils/apiFetch"

export type PctLookupApplicant = {
  name: string
  countryCode: string | null
}

export type PctLookupResult = {
  title: string | null
  internationalFilingDate: string | null
  applicants: PctLookupApplicant[]
  // ISO 639-1 code of the language of the international publication, when the register makes it certain
  publicationLanguage: string | null
  // Office that made the international search report, e.g. EP
  searchAuthority: string | null
}

// Looks the PCT application up at the EPO (Open Patent Services)
export function lookupPctApplication(number: string) {
  return apiFetch(`/api/epo-ops/pct?number=${encodeURIComponent(number)}`) as Promise<PctLookupResult>
}
